import React, {FC, useState} from 'react';

import {useAppDispatch, useAppSelector} from '../../../../helpers/appReduxHelpers';
import {hasNotification, setupNotifications} from '../../../../services/notifications';
import {disableNotificationsPermissionBanner} from '../../../../store/data/localPreferences/localPreferencesActions';
import {getShouldShowNotificationsPermissionBanner} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {getWasOnboardingCompleted} from '../../../../store/data/preferences/preferencesSelectors';
import {getAvailableSetupGuide, SetupGuideEnum} from '../../../../store/stateless/onboardingSelectors';
import {NotificationsPermissionBanner} from './notificationsPermissionBanner';

/*
 * Component.
 */

export const NotificationsPermissionBannerContainer: FC = () => {
  // Delay banner display until the user has completed onboarding tasks.
  const wasOnboardingCompleted = useAppSelector(getWasOnboardingCompleted);
  const setupGuide = useAppSelector(getAvailableSetupGuide);
  const shouldDisplayBannerPreference = useAppSelector(getShouldShowNotificationsPermissionBanner);

  const initialValue =
    hasNotification() && Notification.permission === 'default' && shouldDisplayBannerPreference;
  const [shouldDisplayBanner, setSouldDisplayBanner] = useState(initialValue);
  const dispatch = useAppDispatch();
  if (!shouldDisplayBanner || !wasOnboardingCompleted || setupGuide === SetupGuideEnum.ADMIN) {
    return null;
  }

  return (
    <NotificationsPermissionBanner
      onDismissClick={() => {
        dispatch(disableNotificationsPermissionBanner());
        setSouldDisplayBanner(false);
      }}
      onEnableClick={() => {
        setupNotifications();
        setSouldDisplayBanner(false);
      }}
    />
  );
};
